import classNames from 'classnames';
import { Eye, EyeOff } from 'react-feather';
import { useTranslation } from 'react-i18next';

import { useMutation } from '../../../Shared/api';
import { useNotifier } from '../../../Shared/Notifier/NotificationProvider';
import { Project } from '../../../Shared/types';
import { Toggle } from '../../../Shared/UI/Toggle';
import { useRouter } from '../../router';

export default function ProjectToggle({
  project,
}: {
  project: Project;
}) {
  const { t } = useTranslation();
  const { routes } = useRouter();
  const notifier = useNotifier();

  const [toggleProject, { loading }] = useMutation(routes.toggle_project(project.id), {
    preserveScroll: true,
    onSuccess: () => {
      notifier.notify(
        !project.enabled ? t('backend:project_enabled') : t('backend:project_disabled'),
        !project.enabled ? Eye : EyeOff
      );
    },
  });

  return (
    <div className="inline-flex items-center space-x-4">
      <div className={classNames('font-medium', project.enabled ? 'text-emerald-600' : 'text-slate-500')}>
        {project.enabled ? t('backend:live') : t('backend:offline')}
      </div>
      <div className="z-20">
        <Toggle
          checked={project.enabled}
          onChange={() => toggleProject({ enabled: !project.enabled })}
          disabled={project.default || loading}
        />
      </div>
    </div>
  );
}
